<template>
    <div class="Main" style="padding-bottom:0;">
        <div class="topMain">
            <div slot="header" class="clearfix">
                <span>登录日志</span>
                <el-button type="warning" icon="el-icon-download" @click="handleExport" v-has="'loginLog:loginExport'" style="float: right;margin-right:20px">导出</el-button>
                <el-button type="danger" icon="el-icon-delete" @click="handleClean" v-has="'loginLog:loginClear'" style="float: right;margin-right:20px">清空</el-button>
                <el-button type="danger" icon="el-icon-delete" @click="handleDelete" v-has="'loginLog:loginDel'" style="float: right;margin-right:20px">删除</el-button>
            </div>
        </div>
        <div style="margin-top: 15px;">
            <el-form :model="queryParams" ref="queryParams" :inline="true" class="demo-form-inline">
                <el-form-item label="用户名称" prop="userName">
                    <el-input placeholder="请输入" v-model="queryParams.userName"></el-input>
                </el-form-item>
                <el-form-item label="登录状态" prop="status">
                    <el-select placeholder="请选择" v-model="queryParams.status">
                        <el-option label="成功" value="0"></el-option>
                        <el-option label="失败" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="登录时间">
                    <el-date-picker v-model="dateRange"  style="width: 240px" type="daterange" range-separator="-" start-placeholder="开始日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class=" checkPlandiv_but">
                    <el-button type="primary" @click="handleQuery">搜索</el-button>
                    <el-button @click="resetQuery"><i class="el-icon-refresh"></i>重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">

            </el-col>
            <el-col :span="1.5">

            </el-col>
            <el-col :span="1.5">

            </el-col>
        </el-row>
        <el-card>
            <el-table ref="tables" v-loading="loading" :data="list" @selection-change="handleSelectionChange" :default-sort="defaultSort" @sort-change="handleSortChange">
                <el-table-column type="selection" width="55" align="center" />
                <el-table-column label="序号" align="center" type="index" />
                <el-table-column label="用户名称" align="center" prop="userName" :show-overflow-tooltip="true" sortable="custom" />
                <el-table-column label="登录地址" align="center" prop="ipaddr" width="130" :show-overflow-tooltip="true" />
                <el-table-column label="登录地点" align="center" prop="loginLocation" :show-overflow-tooltip="true" />
                <el-table-column label="浏览器" align="center" prop="browser" :show-overflow-tooltip="true" />
                <el-table-column label="操作系统" align="center" prop="os" />
                <el-table-column label="登录状态" align="center" prop="status">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.status == 0">成功</el-tag>
                        <el-tag type="danger" v-if="scope.row.status == 1">失败</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作信息" align="center" prop="msg" />
                <el-table-column label="登录日期" align="center" :formatter="dateFormat" prop="loginTime" sortable="custom" :sort-orders="['descending', 'ascending']" width="180">
                    <!-- <template slot-scope="scope">
                        <span>{{ scope.row.loginTime }}</span>
                    </template> -->
                </el-table-column>
            </el-table>
        </el-card>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.pageNum" :page-sizes="[10,50,100,200,500,1000]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
</template>

<script>
import API from "../../api/api";
import dayjs from "dayjs";
export default {
    name: "Logininfor",

    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 表格数据
            list: [],
            // 日期范围
            dateRange: [],
            // 默认排序
            defaultSort: { prop: 'loginTime', order: 'descending' },
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                ipaddr: '',
                userName: '',
                status: '',
                beginTime: '',
                endTime: ''
            },
            dictData: [
                { label: '成功', value: '0' },
                { label: '失败', value: '1' },
            ]
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询登录日志列表 */
        getList() {
            this.loading = true;
            if (this.dateRange.length > 0) {
                this.queryParams.beginTime = this.dateRange[0]
                this.queryParams.endTime = this.dateRange[1]
            } else {
                this.queryParams.beginTime = ''
                this.queryParams.endTime = ''
            }
            API.loginLogList(this.queryParams).then(response => {
                this.list = response.data.resultPage;
                this.total = response.data.total;
                this.loading = false;
            }
            );
        },
        dateFormat(row, column, cellValue, index) {
            if (row[column.property]) {
            return dayjs(new Date(row[column.property])).format("YYYY-MM-DD HH:mm:ss")
            } else {
            return '--'
            }
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.dateRange = [];
            this.$refs["queryParams"].resetFields();
            this.$refs.tables.sort(this.defaultSort.prop, this.defaultSort.order)
            this.handleQuery();
        },
        /** 多选框选中数据 */
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.infoId)
            this.multiple = !selection.length
        },
        /** 排序触发事件 */
        handleSortChange(column, prop, order) {
            this.queryParams.orderByColumn = column.prop;
            this.queryParams.isAsc = column.order;
            this.getList();
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const infoIds = row.infoId || this.ids;
            this.$confirm('是否确认删除当前选中的数据项？').then(function () {
                return API.delLogininfor(infoIds);
            }).then(() => {
                this.getList();
                this.$message.success('删除成功')
            }).catch(() => { });
        },
        /** 清空按钮操作 */
        handleClean() {
            this.$confirm('是否确认清空所有登录日志数据项？').then(function () {
                return API.cleanLogininfor();
            }).then(() => {
                this.getList();
                this.$message.success('清空成功')
            }).catch(() => { });
        },
        /** 导出按钮操作 */
        handleExport() {
            // this.download('monitor/logininfor/export', {
            //     ...this.queryParams
            // }, `logininfor_${new Date().getTime()}.xlsx`)
            let params = JSON.parse(JSON.stringify(this.queryParams))
            params.pageSize = 100000
            window.open(API.exportLoginLogUrl(params))
        },
        //分页
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.queryParams.pageNum = 1
            this.getList()
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList()
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/views/platform/loginLog.vue